import React, { useEffect, useRef } from "react";
import ChatBubble from "./ChatBubble";

export default function MessageList({ messages = [], onChipClick }) {
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
    <div style={styles.list}>
      {messages.map((m) => (
        <ChatBubble
          key={m.id}
          role={m.role}
          text={m.text}
          meta={m.meta}
          typing={m.typing}
          timestamp={m.timestamp}
          onChipClick={onChipClick}
        />
      ))}
      <div ref={bottomRef} />
    </div>
  );
}

const styles = {
  list: {
    flex: 1,
    overflowY: "auto",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
};
